const pagesApi = ({ apiClient }) => ({
  list() {
    return apiClient.get('pages')
  },
  show(id) {
    return apiClient.get(`pages/${id}`)
  },
  update(id, payload) {
    return apiClient.put(`pages/${id}`, payload)
  },
})

export default pagesApi
